var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupSigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91671 12.8334H11.0834C11.4055 12.8334 11.6667 12.5722 11.6667 12.25V4.08335H8.75004V1.16669H2.91671C2.59454 1.16669 2.33337 1.42785 2.33337 1.75002V12.25C2.33337 12.5722 2.59454 12.8334 2.91671 12.8334Z",
    stroke: "#6A75CA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.16669L11.6667 4.08335",
    stroke: "#6A75CA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 8.16665C7.64437 8.16665 8.16671 7.64431 8.16671 6.99998C8.16671 6.35565 7.64437 5.83331 7.00004 5.83331C6.35571 5.83331 5.83337 6.35565 5.83337 6.99998C5.83337 7.64431 6.35571 8.16665 7.00004 8.16665Z",
    stroke: "#6A75CA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 10.5C9.33329 9.21135 8.28863 8.16669 6.99996 8.16669C5.71129 8.16669 4.66663 9.21135 4.66663 10.5",
    stroke: "#6A75CA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSigner);
export default __webpack_public_path__ + "static/media/group-signer.5e98e21c2cfeecf59049c6f3d0fbea53.svg";
export { ForwardRef as ReactComponent };